"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var tool_1 = require("mobile/utils/tool");
var tool_2 = require("mobile/utils/tool");
var throttle_1 = require("utils/throttle");
var styles = require("./index.scss");
var MProductsTag = (function (_super) {
    __extends(MProductsTag, _super);
    function MProductsTag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            categoryFixed: false
        };
        _this.scroll = function (event) {
            var _a = _this.props, moduleDetail = _a.moduleDetail, hasTitle = _a.hasTitle, navFixed = _a.navFixed;
            if (!navFixed) {
                if (moduleDetail && moduleDetail.module.proModules) {
                    var _b = _this.props, topMap = _b.topMap, index = _b.index;
                    var scrollTop = (event.srcElement ? event.srcElement.documentElement.scrollTop : false) ||
                        window.pageYOffset ||
                        (event.srcElement ? event.srcElement.body.scrollTop : 0);
                    var LTFixedHeight = hasTitle ? tool_1.getPxByRem(3) : 0;
                    var LTCondition = topMap &&
                        scrollTop >= topMap[index].offsetTop + tool_1.getPxByRem(0.5) - LTFixedHeight &&
                        topMap[index].getBoundingClientRect().bottom >= 0;
                    if (LTCondition) {
                        _this.setState({
                            categoryFixed: true
                        });
                    }
                    else {
                        _this.setState({
                            categoryFixed: false
                        });
                    }
                }
            }
        };
        _this.tabClick = function (e, i, item) {
            e.stopPropagation();
            var _a = _this.props, moduleMap = _a.moduleMap, index = _a.index, navFixed = _a.navFixed, hasTitle = _a.hasTitle, changeActiveTab = _a.changeActiveTab;
            changeActiveTab(item, i);
            tool_2.replaceUrl("floor" + index, item.name);
            var categoryFixed = _this.state.categoryFixed;
            if (categoryFixed && !navFixed) {
                var topFixed = void 0, top = void 0;
                topFixed = hasTitle ? 30 : 0;
                top = moduleMap[index - 1].item.offsetTop - topFixed;
                window.scrollTo(0, top);
            }
        };
        _this.getColor = function (source, needle, defaultColor) {
            return source && source.colorTable && source.colorTable[needle]
                ? source.colorTable[needle]
                : defaultColor;
        };
        _this.getStyle = function (isFixed) {
            var _a = _this.props, ui = _a.ui, hasTitle = _a.hasTitle;
            var style = {};
            style.backgroundColor = ui && ui.bgColor ? ui.bgColor : "#fff";
            style.top = isFixed && hasTitle ? "3rem" : "0";
            return style;
        };
        return _this;
    }
    MProductsTag.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var _c = this.props, navFixed = _c.navFixed, ui = _c.ui, proModules = _c.proModules, activeTab = _c.activeTab;
        var categoryFixed = this.state.categoryFixed;
        var isFixed = !navFixed && categoryFixed;
        return (React.createElement("div", { className: classnames_1.default(styles.categoryBox, (_a = {},
                _a[styles.LTCategoryBox] = true,
                _a)) },
            React.createElement("div", { className: classnames_1.default(styles.category, (_b = {},
                    _b[styles.LTCategory] = true,
                    _b[styles.isFixed] = isFixed,
                    _b[styles.cancelFixed] = !isFixed,
                    _b)), style: this.getStyle(isFixed) },
                React.createElement("ul", null, proModules.map(function (item, i) { return (React.createElement("li", { key: i, onClick: function (e) { return _this.tabClick(e, i, item); }, className: styles.tab, style: activeTab === i
                        ? {
                            color: _this.getColor(ui, "textFocusColor", "#fff"),
                            backgroundColor: _this.getColor(ui, "tagFocusBg", "#ff5a00")
                        }
                        : {
                            color: _this.getColor(ui, "textColor", "#333")
                        } }, item.name)); })))));
    };
    MProductsTag.prototype.componentDidMount = function () {
        window.addEventListener("scroll", throttle_1.default(this.scroll, 30));
    };
    MProductsTag.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this.scroll);
    };
    return MProductsTag;
}(React.Component));
exports.default = MProductsTag;
